// [S-058] MCP access info for the tenant Settings "MCP access" section.
// Backed by the admin endpoint:
//   GET /tenants/me/mcp-access
//     → { endpointUrl, status, accessTier, tools }
//
// The web app cannot call the MCP server directly (it's an API-key-gated
// public service, not behind the same IAP), so admin serves this on the
// caller's behalf. Tools come from the canonical core catalog filtered to
// the caller's real tier — never a hardcoded list.
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "./api";

export type McpAccessStatus = "online" | "offline" | "unknown";

export type McpToolInfo = {
  name: string;
  description: string;
  minAccessTier: "basic" | "professional" | "enterprise";
  requiredLayers: ReadonlyArray<"L1" | "L2">;
};

export type McpAccess = {
  endpointUrl: string | null;
  status: McpAccessStatus;
  accessTier: "basic" | "professional" | "enterprise";
  tools: McpToolInfo[];
};

export const MCP_ACCESS_KEY = ["mcp-access"] as const;

export function useMcpAccess(
  tenantId: string
): UseQueryResult<McpAccess, Error> {
  const api = useApi("admin");
  return useQuery({
    queryKey: [...MCP_ACCESS_KEY, tenantId] as const,
    enabled: tenantId.length > 0,
    queryFn: () => api<McpAccess>("/tenants/me/mcp-access"),
  });
}
